export const animeList = [
  {
    id: 1,
    title: '星海彼岸的约定',
    genre: '奇幻',
    tags: ['冒险', '群像', '史诗'],
    year: 2025,
    status: '连载中',
    episodes: 24,
    rating: 9.4,
    summary: '两位少年在星环坠落的夜晚上路，穿越浮空群岛寻找失落的航海图，旅程中逐渐读懂彼此未曾说出口的约定。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20two%20young%20travelers%20standing%20on%20a%20cliff%20edge%20beneath%20a%20vast%20starry%20ocean%20sky%2C%20painterly%20soft%20shading%2C%20warm%20sakura%20pink%20and%20deep%20amber%20palette%2C%20cinematic%20vertical%20illustration%2C%20dreamy%20atmosphere%2C%20no%20text&width=600&height=800&seq=anime-poster-01&orientation=portrait',
  },
  {
    id: 2,
    title: '暮色咖啡厅',
    genre: '治愈',
    tags: ['日常', '美食', '慢节奏'],
    year: 2024,
    status: '已完结',
    episodes: 13,
    rating: 9.1,
    summary: '街角咖啡厅每晚只接待一位客人，店主根据对方的状态冲调一杯专属饮品，客人也在热气里讲完了自己的故事。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20cozy%20evening%20cafe%20with%20warm%20hanging%20lights%20and%20a%20gentle%20barista%20by%20the%20window%2C%20painterly%20soft%20shading%2C%20warm%20amber%20and%20cream%20palette%2C%20cinematic%20vertical%20illustration%2C%20calm%20mood%2C%20no%20text&width=600&height=800&seq=anime-poster-02&orientation=portrait',
  },
  {
    id: 3,
    title: '剑与樱的旅途',
    genre: '热血',
    tags: ['剑戟', '成长', '修行'],
    year: 2025,
    status: '连载中',
    episodes: 18,
    rating: 9.3,
    summary: '年轻剑客背着旧刀行走樱花山道，一路上用切磋代替争斗，在被击败的对手身上学到比招式更重要的东西。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20lone%20samurai%20walking%20a%20petal%20covered%20mountain%20path%20with%20a%20katana%20on%20the%20back%2C%20painterly%20soft%20shading%2C%20sakura%20pink%20and%20sunset%20gold%20palette%2C%20cinematic%20vertical%20illustration%2C%20no%20text&width=600&height=800&seq=anime-poster-03&orientation=portrait',
  },
  {
    id: 4,
    title: '夏日回声',
    genre: '校园',
    tags: ['青春', '恋爱', '海边'],
    year: 2024,
    status: '已完结',
    episodes: 12,
    rating: 9.0,
    summary: '搬来海边小镇的转学生加入了濒临解散的广播部，用一台旧设备记录下一个夏天里所有没能当面说出的话。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20high%20school%20students%20by%20a%20seaside%20railway%20under%20bright%20summer%20clouds%2C%20painterly%20soft%20shading%2C%20warm%20coral%20and%20mint%20palette%2C%20cinematic%20vertical%20illustration%2C%20nostalgic%20mood%2C%20no%20text&width=600&height=800&seq=anime-poster-04&orientation=portrait',
  },
  {
    id: 5,
    title: '雾都侦探录',
    genre: '悬疑',
    tags: ['推理', '单元剧', '推理社'],
    year: 2025,
    status: '连载中',
    episodes: 20,
    rating: 9.2,
    summary: '常年潮湿的老城每晚都有新的谜题，私家侦探靠观察力与耐心拆解线索，把看似无关的细节重新串回原处。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20detective%20in%20a%20long%20coat%20on%20a%20foggy%20vintage%20city%20street%20at%20night%2C%20painterly%20soft%20shading%2C%20muted%20amber%20and%20teal%20palette%2C%20cinematic%20vertical%20illustration%2C%20mysterious%20mood%2C%20no%20text&width=600&height=800&seq=anime-poster-05&orientation=portrait',
  },
  {
    id: 6,
    title: '机械之心',
    genre: '科幻',
    tags: ['机甲', '战争', '羁绊'],
    year: 2025,
    status: '连载中',
    episodes: 22,
    rating: 9.1,
    summary: '少年驾驶员与一台脾气古怪的老式机甲搭档，在资源匮乏的荒原上完成运输任务，也在磨合中学会信任。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20young%20pilot%20beside%20a%20towering%20friendly%20mecha%20in%20a%20desert%20sunrise%2C%20painterly%20soft%20shading%2C%20warm%20orange%20and%20steel%20grey%20palette%2C%20cinematic%20vertical%20illustration%2C%20no%20text&width=600&height=800&seq=anime-poster-06&orientation=portrait',
  },
  {
    id: 7,
    title: '春分时节的来信',
    genre: '恋爱',
    tags: ['治愈', '慢热', '书信'],
    year: 2024,
    status: '已完结',
    episodes: 13,
    rating: 9.0,
    summary: '两位从未碰面的笔友交换了整整一年书信，直到春分那天，最后一封信把他们带到了同一棵树下。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20girl%20reading%20a%20handwritten%20letter%20under%20blooming%20spring%20trees%2C%20painterly%20soft%20shading%2C%20soft%20pink%20and%20fresh%20green%20palette%2C%20cinematic%20vertical%20illustration%2C%20gentle%20mood%2C%20no%20text&width=600&height=800&seq=anime-poster-07&orientation=portrait',
  },
  {
    id: 8,
    title: '龙脊之城',
    genre: '奇幻',
    tags: ['冒险', '城堡', '群像'],
    year: 2025,
    status: '连载中',
    episodes: 16,
    rating: 9.3,
    summary: '依山而建的古城依靠一条沉睡的巨龙维持结界，守卫学徒必须在仪式失效前找到与它沟通的方式。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20mountain%20fortress%20city%20with%20a%20dragon%20circling%20ancient%20towers%2C%20painterly%20soft%20shading%2C%20warm%20bronze%20and%20deep%20green%20palette%2C%20cinematic%20vertical%20illustration%2C%20epic%20mood%2C%20no%20text&width=600&height=800&seq=anime-poster-08&orientation=portrait',
  },
  {
    id: 9,
    title: '面包店的午后',
    genre: '治愈',
    tags: ['美食', '日常', '温暖'],
    year: 2024,
    status: '已完结',
    episodes: 12,
    rating: 8.9,
    summary: '小镇面包店每天只出炉固定数量，老板记得每位熟客的口味，也记得他们生活里那些悄悄发生的变化。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20sunny%20bakery%20interior%20with%20fresh%20bread%20on%20wooden%20shelves%20and%20a%20smiling%20baker%2C%20painterly%20soft%20shading%2C%20warm%20cream%20and%20honey%20palette%2C%20cinematic%20vertical%20illustration%2C%20no%20text&width=600&height=800&seq=anime-poster-09&orientation=portrait',
  },
  {
    id: 10,
    title: '暗河追凶',
    genre: '悬疑',
    tags: ['刑侦', '群像', '烧脑'],
    year: 2025,
    status: '连载中',
    episodes: 18,
    rating: 9.2,
    summary: '城市地下的排水管网里藏着一连串谜团的答案，调查组沿着潮湿的通道一步步逼近被掩埋的真相。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20rain%20soaked%20underpass%20with%20a%20solitary%20investigator%20holding%20a%20flashlight%2C%20painterly%20soft%20shading%2C%20dark%20amber%20and%20slate%20palette%2C%20cinematic%20vertical%20illustration%2C%20tense%20mood%2C%20no%20text&width=600&height=800&seq=anime-poster-10&orientation=portrait',
  },
  {
    id: 11,
    title: '旋转木马少年',
    genre: '校园',
    tags: ['青春', '友情', '夏日祭'],
    year: 2024,
    status: '已完结',
    episodes: 12,
    rating: 8.8,
    summary: '五个性格迥异的同学接下夏日祭的运营委托，在一次次手忙脚乱中把一场普通的祭典办成了难忘的回忆。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20teenagers%20laughing%20on%20a%20carousel%20at%20a%20summer%20festival%20at%20dusk%2C%20painterly%20soft%20shading%2C%20warm%20peach%20and%20gold%20palette%2C%20cinematic%20vertical%20illustration%2C%20joyful%20mood%2C%20no%20text&width=600&height=800&seq=anime-poster-11&orientation=portrait',
  },
  {
    id: 12,
    title: '万花筒剧场',
    genre: '奇幻',
    tags: ['单元剧', '脑洞', '舞台'],
    year: 2025,
    status: '连载中',
    episodes: 14,
    rating: 9.0,
    summary: '一座会在午夜自动开演的剧院，每集上演一个独立故事，台下的观众却在不知不觉中成为剧中人。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20magical%20theatre%20stage%20with%20floating%20kaleidoscope%20props%20and%20performers%2C%20painterly%20soft%20shading%2C%20warm%20rose%20and%20amber%20palette%2C%20cinematic%20vertical%20illustration%2C%20whimsical%20mood%2C%20no%20text&width=600&height=800&seq=anime-poster-12&orientation=portrait',
  },
  {
    id: 13,
    title: '深海之音',
    genre: '科幻',
    tags: ['音乐', '治愈', '未来'],
    year: 2024,
    status: '已完结',
    episodes: 13,
    rating: 8.9,
    summary: '未来城市的歌手在废弃海底观测站开了一场无人到场的演唱会，声音却顺着洋流传到了意想不到的地方。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20singer%20on%20a%20glowing%20deep%20sea%20stage%20surrounded%20by%20luminous%20fish%2C%20painterly%20soft%20shading%2C%20warm%20coral%20and%20aqua%20palette%2C%20cinematic%20vertical%20illustration%2C%20no%20text&width=600&height=800&seq=anime-poster-13&orientation=portrait',
  },
  {
    id: 14,
    title: '旧书店的秘密',
    genre: '悬疑',
    tags: ['日常', '解谜', '温情'],
    year: 2025,
    status: '连载中',
    episodes: 12,
    rating: 9.1,
    summary: '老书店每本旧书里都夹着一张不知来处的便签，店主与常客猫一起，把便签上的碎片拼成完整的故事。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20dusty%20old%20bookstore%20with%20stacks%20of%20books%20and%20a%20curious%20cat%20on%20the%20counter%2C%20painterly%20soft%20shading%2C%20warm%20sepia%20and%20cream%20palette%2C%20cinematic%20vertical%20illustration%2C%20cozy%20mood%2C%20no%20text&width=600&height=800&seq=anime-poster-14&orientation=portrait',
  },
];

export const genreOptions = ['全部', '热血', '奇幻', '恋爱', '校园', '治愈', '悬疑', '科幻'];

export const rankingList = [
  { rank: 1, title: '星海彼岸的约定', genre: '奇幻', heat: '128.6万', trend: 'up', summary: '本周更新第 24 集，浮空群岛终章进入关键节点。' },
  { rank: 2, title: '剑与樱的旅途', genre: '热血', heat: '117.3万', trend: 'up', summary: '第 18 集剑客迎来首次真正的败北，讨论热度攀升。' },
  { rank: 3, title: '龙脊之城', genre: '奇幻', heat: '109.8万', trend: 'flat', summary: '结界仪式线收束，古城的夜间场景成为截图热点。' },
  { rank: 4, title: '雾都侦探录', genre: '悬疑', heat: '96.4万', trend: 'up', summary: '单元案与主线首次交汇，线索密度明显提升。' },
  { rank: 5, title: '机械之心', genre: '科幻', heat: '88.7万', trend: 'down', summary: '机甲磨合段落偏日常，观众评价出现分化。' },
  { rank: 6, title: '暗河追凶', genre: '悬疑', heat: '82.1万', trend: 'up', summary: '地下管网追捕段落节奏紧凑，口碑持续走高。' },
  { rank: 7, title: '万花筒剧场', genre: '奇幻', heat: '75.5万', trend: 'flat', summary: '单元故事风格多变，适合零散时间观看。' },
  { rank: 8, title: '旧书店的秘密', genre: '悬疑', heat: '69.2万', trend: 'up', summary: '温情解谜路线稳定吸粉，适合睡前观看。' },
];

export const scheduleData = [
  { day: '周一', weekday: 'Monday', items: [
    { title: '星海彼岸的约定', time: '19:00', episode: '第 25 集', genre: '奇幻' },
    { title: '暮色咖啡厅', time: '21:30', episode: '番外篇', genre: '治愈' },
  ] },
  { day: '周二', weekday: 'Tuesday', items: [
    { title: '剑与樱的旅途', time: '18:30', episode: '第 19 集', genre: '热血' },
    { title: '深海之音', time: '22:00', episode: '特别篇', genre: '科幻' },
  ] },
  { day: '周三', weekday: 'Wednesday', items: [
    { title: '雾都侦探录', time: '20:00', episode: '第 21 集', genre: '悬疑' },
    { title: '面包店的午后', time: '21:00', episode: '重制版', genre: '治愈' },
  ] },
  { day: '周四', weekday: 'Thursday', items: [
    { title: '龙脊之城', time: '19:30', episode: '第 17 集', genre: '奇幻' },
    { title: '旋转木马少年', time: '22:30', episode: '合集', genre: '校园' },
  ] },
  { day: '周五', weekday: 'Friday', items: [
    { title: '机械之心', time: '18:00', episode: '第 23 集', genre: '科幻' },
    { title: '夏日回声', time: '20:30', episode: '特别篇', genre: '校园' },
  ] },
  { day: '周六', weekday: 'Saturday', items: [
    { title: '暗河追凶', time: '19:00', episode: '第 19 集', genre: '悬疑' },
    { title: '万花筒剧场', time: '21:00', episode: '第 15 集', genre: '奇幻' },
  ] },
  { day: '周日', weekday: 'Sunday', items: [
    { title: '旧书店的秘密', time: '18:30', episode: '第 13 集', genre: '悬疑' },
    { title: '春分时节的来信', time: '20:00', episode: '全集合集', genre: '恋爱' },
  ] },
];

export const highlightItems = [
  { icon: 'ri-hd-line', title: '高清画质', desc: '默认提供高清片源，支持在播放页按网络情况手动切换清晰度。' },
  { icon: 'ri-shield-check-line', title: '无广告打扰', desc: '观看过程不插入弹窗与中断式广告，减少对剧情连贯性的影响。' },
  { icon: 'ri-stack-line', title: '全集收录', desc: '已完结作品按全集整理，连载作品随更新补齐，便于一次性补完。' },
  { icon: 'ri-money-cny-circle-line', title: '免费浏览', desc: '浏览与查看作品信息完全免费，不需要注册账号即可了解内容。' },
];

export const guideSteps = [
  { step: '01', title: '按题材定位', desc: '在浏览区选择热血、治愈、悬疑等题材标签，列表会即时筛选出符合口味的作品。' },
  { step: '02', title: '关键词查找', desc: '记不清完整片名时，输入标题里的任意关键词，即可在已收录内容中定位到目标作品。' },
  { step: '03', title: '查看详情再决定', desc: '卡片上标注更新状态、集数与评分，读完简介再决定从哪一部开始，不浪费时间。' },
  { step: '04', title: '按时间表追更', desc: '连载作品按每周更新表标注时间，喜欢追更可以按时间表安排观看节奏。' },
];

export const faqList = [
  { q: '樱花动漫在线提供哪些内容？', a: '本页围绕在线观看整理内容，主要覆盖观看、播放、高清与免费几类信息，并补充全集与无广告相关说明，适合按具体需求继续查找作品。' },
  { q: '需要注册账号才能浏览吗？', a: '不需要。浏览作品介绍、更新状态、集数和评分都可以直接进行，阅读内容不依赖登录，也不需要提交任何个人信息。' },
  { q: '连载作品会多久更新一次？', a: '连载作品一般按每周固定节奏更新，页面的更新时间表会标注大致的更新日与时间段，具体以当周实际更新为准。' },
  { q: '已完结的作品能看到完整集数吗？', a: '已完结作品在卡片上会标注为“已完结”，并给出总集数，方便按全集一次性补完；连载作品则显示当前已更新到的集数。' },
  { q: '如何快速找到想看的那一部？', a: '可以先用题材标签缩小范围，再在搜索框输入标题关键词；两者可以叠加使用，筛选与搜索只作用于本页已经列出的内容。' },
  { q: '页面上的评分和热度代表什么？', a: '评分与热度用于辅助判断作品受关注程度，属于展示用的参考信息，并不构成对作品质量的绝对结论，选择时仍建议结合简介与题材。' },
  { q: '手机上看排版会乱吗？', a: '页面针对桌面与移动端分别调整了排版，卡片会在窄屏下自动变为单列或双列，筛选标签与列表文字保持可读，手机上可以顺畅浏览。' },
];